import apis from "../../config/apis.json";
import { getAccessToken } from "../msal";
import { IPublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import {
  IUser,
} from "./interfaces";
import { TRIAL_TRACKER_APP_ID } from "constants/app";

/**
 * Creates a user.
 *
 * @param instance The MSAL client instance.
 * @param request The user.
 * @returns The created user.
 */
export async function postUser(instance: IPublicClientApplication, request: IUser): Promise<IUser> {
  const { scope, baseUrl } = apis.security;
  const requestUrl = `${baseUrl}/apps/${TRIAL_TRACKER_APP_ID}/userbyrolecollection`;
  const accessToken = await getAccessToken(instance, scope);

  const result = await axios.post(
    requestUrl,
    request,
    {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      }
    }
  );

  return result.data;
}

/**
 * Updates a user.
 *
 * @param instance The MSAL client instance.
 * @param request The user.
 * @returns The created user.
 */
export async function putUser(instance: IPublicClientApplication, request: IUser, etag: string): Promise<IUser> {
  const { scope, baseUrl } = apis.security;
  const requestUrl = `${baseUrl}/apps/${TRIAL_TRACKER_APP_ID}/userbyrolecollection/${request.id}`;
  const accessToken = await getAccessToken(instance, scope);

  const result = await axios.put(
    requestUrl,
    request,
    {
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        "If-Match": etag
      }
    }
  );

  return result.data;
}
